import { useContext, useState } from 'react'
import { useParams } from 'react-router'

import Card, { CardContent } from 'js/components/Card'
import Flexer from 'js/components/Flexer/Flexer'
import { Col, Container, Row } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import ToggleTranslation from 'js/components/Item/components/ToggleTranslation'
import ItemActions from 'js/components/Item/ItemActions/ItemActions'
import Author from 'js/components/Item/ItemHeader/components/Author'
import ItemStatusTag from 'js/components/Item/ItemStatusTag'
import Section from 'js/components/Section/Section'
import TiptapView from 'js/components/Tiptap/TiptapView'
import { globalStateContext } from 'js/lib/GlobalState'

import TextPageNav from './TextPageNav/TextPageNav'

const Text = ({ entity }) => {
    const {
        globalState: { editMode },
    } = useContext(globalStateContext)

    const { containerGuid } = useParams()

    const {
        guid,
        title,
        richDescription,
        statusPublished,
        showOwner,
        owner,
        localTitle,
        localRichDescription,
        isTranslationEnabled,
    } = entity

    const hasTranslations =
        (!!localTitle || !!localRichDescription) && isTranslationEnabled

    const [isTranslated, setIsTranslated] = useState(hasTranslations)

    const translatedTitle = isTranslated ? localTitle : title

    const translatedRichDescription = isTranslated
        ? localRichDescription
        : richDescription

    const onEdit = `/page/edit/${guid}`
    const onAfterDelete = '/admin/pages'

    const isPublished = statusPublished === 'published'

    const showAuthor = showOwner && owner

    const page = (
        <Card>
            <CardContent>
                {showAuthor && (
                    <Author entity={entity} style={{ marginBottom: '16px' }} />
                )}
                <Flexer alignItems="flex-start" gutter={false}>
                    <H1
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }}
                    >
                        {translatedTitle}
                        <ItemStatusTag
                            entity={entity}
                            style={{
                                marginTop: '8px',
                            }}
                        />
                    </H1>
                    <ItemActions
                        canChangeAccess
                        canDuplicate
                        showEditButton
                        entity={entity}
                        onEdit={onEdit}
                        onAfterDelete={onAfterDelete}
                        refetchQueries={['PageView']}
                        style={{ marginLeft: 'auto' }}
                    />
                </Flexer>

                <TiptapView
                    content={translatedRichDescription}
                    style={{ marginTop: '16px' }}
                />

                {hasTranslations && (
                    <ToggleTranslation
                        isTranslated={isTranslated}
                        setIsTranslated={setIsTranslated}
                        style={{ marginTop: '12px' }}
                    />
                )}
            </CardContent>
        </Card>
    )

    return (
        <Section>
            {isPublished ? (
                <Container>
                    <Row>
                        <Col mobileLandscapeUp={1 / 3} tabletUp={1 / 4}>
                            <TextPageNav
                                guid={containerGuid || guid}
                                editMode={editMode}
                            />
                        </Col>
                        <Col mobileLandscapeUp={2 / 3} tabletUp={3 / 4}>
                            {page}
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Container size="normal">{page}</Container>
            )}
        </Section>
    )
}

export default Text
